define(['jquery','erv_autosuggest'], function ($, ERVAutosuggest) {

	var ResponsiveMainSearch = function ($header) {
		var self = this;
		self.$searchContainer = $header.find('#main-search');
		self.$searchButton = self.$searchContainer.find('#main-search-button');
		self.$searchInput = self.$searchContainer.find('#main-search-input');

        self.hideSearchInput = function () {
            ERVAutosuggest.default.clearSuggestionsContainer();
		}

		self.isSuggestion = function ($el) {
			return $el.is(ERVAutosuggest.default.SUGGESTION_SELECTOR) || $el.parent().is(ERVAutosuggest.default.SUGGESTION_SELECTOR)
        }

		self.addEventListener = function () {

			self.$searchButton.on('click', function (e) {
				e.preventDefault();

				if (self.$searchInput.val().length > 0) {
					self.$searchContainer.submit();
					return false;
				}

                ERVAutosuggest.default.clearSuggestionsContainer();
			});

			self.$searchInput.on('blur', function (e) {
				var $activeElement = $(document.activeElement)
				//if blur because button is pressed
				if (e.relatedTarget != null || $activeElement.is('button')) {
					self.$searchContainer.addClass('blurred');
				} else if (!self.isSuggestion($activeElement)) {
					self.hideSearchInput();
                }
			});
		}

		self.removeEventListener = function () {
			self.$searchButton.unbind();
		}
	};

	ResponsiveMainSearch.prototype.initSmallDevice = function () {
		var self = this;
		self.removeEventListener();
	}

	ResponsiveMainSearch.prototype.initLargerDevice = function () {
		var self = this;
		self.removeEventListener();
		self.addEventListener();
	}

	return ResponsiveMainSearch;
});